import { Component } from '@angular/core';

@Component({
  selector: 'landing-quotes',
  templateUrl: './quotes.component.html',
  styleUrls: ['./quotes.component.scss'],
})
export class QuotesComponent {}
